import { render, staticRenderFns } from "./ClubDesignationCrud.vue?vue&type=template&id=39f32ed4&scoped=true&"
import script from "./ClubDesignationCrud.vue?vue&type=script&lang=js&"
export * from "./ClubDesignationCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f32ed4",
  null
  
)

export default component.exports